import { render, staticRenderFns } from "./KnowledgeBaseAgent.vue?vue&type=template&id=e234a2d0&scoped=true&"
import script from "./KnowledgeBaseAgent.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseAgent.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseAgent.vue?vue&type=style&index=0&id=e234a2d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e234a2d0",
  null
  
)

export default component.exports